import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "sr-only loadingMsg",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "lds-spinner",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div"),
      _createElementVNode("div")
    ], -1))
  ]))
}